<template>
  <div id="site_notice">
    <div v-if="!showDetail">
      <div class="tabbar">
        <div :class="item===selectItem?'isAcitve':''" v-for="(item,index) in tabbarItem" :key="index"
             @click="clickItem(item,index)">
          {{ item }}
        </div>
        <!--      <div class="readAll">123</div>-->
        <span :class="['all_read', totalCount === 0 ? 'all_read--disabled' : '']" @click="totalCount !== 0 && readAll()">
          <i class="iconfont icon-read-all"></i>
          全部已读
        </span>
      </div>
      <div class="notice_list" v-if="totalCount !== 0">
        <div :class="item.status === 0 ?'notice_list_item_unread':'notice_list_item'" class="notice_wrapper"
             v-for="(item,index) in tableData" :key="index" @click="checkNotice(item,index)">
          <div class="notice_left"></div>
          <div class="notice_center">
            <div class="not_cen_top">
              <div class="not_cen_title">{{item.product_type == 16 ? '求降价通知' : '系统通知'}}</div>
              <div class="not_cen_time">
                {{ item.add_time|moments }}
              </div>
            </div>
            <div class="notice_content">
              <div class="item_content">{{ item.content }}</div>
              <div class="item_state">
                <el-tag v-if="item.status ===0 " type="warning" size="medium">未读</el-tag>
                <el-tag v-else type="info" size="medium">已读</el-tag>
              </div>
            </div>
          </div>
          <div class="notice_right">
            <i class="el-icon-caret-right"></i>
          </div>
        </div>
        <div class="pages" v-if="totalCount !== 0">
          <common-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="pages"
            :page-size="PageSize"
            layout="prev, pager, next, jumper"
            :total="totalCount">
          </common-pagination>
        </div>
        <div></div>
      </div>
      <div class="notice_list no_data" v-else>
        <empty-state
          title="暂无站内通知"
          description="新的交易、系统和服务消息会在这里展示"
          icon="el-icon-bell"
          :icon-size="52">
        </empty-state>
      </div>
    </div>
    <div class="info" v-else>
      <sell-info :product="productDetail" @backClick="backClick"></sell-info>
    </div>
    <el-dialog
      title="消息通知"
      :visible.sync="sendWxImg"
      width="322px"
      top="35vh"
      center
      custom-class="sendWxImgWrapper"
    >
      <div class="wxImgWrapper">
        <span>老板您好，有买家急需购买您的账号</span>
        <img class="wxchatImg" :src="wxChatImgLink" alt="">
        <div class="Imggreen">
          <img src="@/assets/image/PersonalCenter/SiteNotice/ss.png" alt="">
          微信扫码
        </div>
        <div class="text-tip">添加我的微信，我协助您交易</div>
      </div>

    </el-dialog>
    <wxChatGlobal :visible.sync="merVisible" :describe="customer_describe" :qr_code_url="qr_code_url"></wxChatGlobal>
  </div>
</template>
<script>
import {
  apiStationList, apiStationRead, apiValuationDetail, apiReadAll, apiStationMsg, apiProductInfo, apiStationPay,
  apiUserProductInfo, apiGetCustomerQrcodeInfo, apiGetCustomerQrcodeList, apiconsultclick, earnestDetail, apiEarnestOrderDetail
} from "@/request/API";
import wxChatGlobal from '../../chat/components/wxChatGlobal.vue';
import sellInfo from "@/views/PersonalCenter/Seller/sellInfo";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: '',
  props: {},
  components: {
    wxChatGlobal,
    sellInfo,
    CommonPagination,
    EmptyState
  },
  data() {
    return {
      showDetail: false,
      productDetail: null,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 0,
      // 默认每页显示的条数（可修改）
      PageSize: 10,
      selectItem: '站内通知',
      tabbarItem: ['站内通知'],
      tableData: [],
      //分页页码
      pages: 1,
      // 估价通知弹窗
      // ValuationNoticeDialogVisible: false,
      // 估价账号价值金额
      assess_price: '',
      // 估价客服留言
      assess_price_note: '',
      product_id: '',
      game_id: '',
      sell_customer: '',
      sendWxImg: false,
      wxChatImgLink: '',
      merVisible: false,
      customer_describe: '',
      qr_code_url: ''
    }
  },
  methods: {
    //详情页返回按钮
    backClick() {
      this.showDetail = false
      this.getStationList(this.pages)
    },
    clickItem(item, index) {
      this.selectItem = item
    },
    //分页监听事件
    handleCurrentChange(val) {
      this.getStationList(val)
    },
    getNoticeExpireStatus(props) {
      const {game_id, product_id, order_id} = props
      return apiUserProductInfo({
        game_id,
        id: product_id,
        order_id
      }).then(() => true)
        .catch((err) => {
          this.$alert(err.msg, '消息通知', {
            confirmButtonText: '确认',
            confirmButtonClass: 'site_confirm_btn',
            customClass: 'site_confirm',
          })
          return false
        })
    },
    //查看 站内通知
    async checkNotice(item, index) {
      if(this.$store.state.siteNoticeMsg>0){
        this.$store.commit('set_siteNoticeMsg', this.$store.state.siteNoticeMsg - 1)
      }
      if (item.status === 0) {
        this.$store.commit("set_chat_message", this.$store.state.chat_message - 1)
      }
      // 15 跳转我的奖品 蟹蟹有你活动
      if (item.product_type === 15 && item.inv_id == 1) {
        localStorage.setItem('rewardType', '实物奖品')
        this.$router.push('/personalCenter/Reward')
        apiStationRead({
          id: item.id
        })
        return
      }
      // type 为 10 ，跳转详情页
      if (item.product_type === 10) {
        if (!(await this.getNoticeExpireStatus(item))) {
          return false
        }
        this.productDetail = {
          game_id: item.game_id,
          id: item.product_id,
        }
        this.showDetail = true
        apiStationRead({id: item.id})
        return false
      }

      if (item.product_type === 4) {
        apiValuationDetail({
          id: item.product_id
        }).then(res => {
          this.product_id = item.product_id
          this.game_id = res.data.game_id
          this.$router.push({
            name: 'ValuationInformation',
            query: {
              product_id: this.product_id,
              game_id: this.game_id
            }
          })
          apiStationRead({
            id: item.id
          }).then(res => {
            this.getStationList(this.pages)
          })
        })
      } else if (item.product_type === 5) {
        // let index = item.content.indexOf("。") + 1
        // let content_top = item.content.slice(0,index)
        // let content_a = item.content.slice(index)
        this.$alert(item.content, '消息通知', {
          confirmButtonText: "认证信息",
          confirmButtonClass: 'site_confirm_btn',
          customClass: 'site_confirm',
        }).then(() => {
          window.open(item.content_link, "_blank")
          apiStationRead({
            id: item.id
          }).then(res => {
            this.getStationList(this.pages)
          })
        }).catch(() => {
          apiStationRead({
            id: item.id
          }).then(res => {
            this.getStationList(this.pages)
          })
        });
      } else if (item.product_type === 6) {
        this.$alert(item.content, '消息通知', {
          confirmButtonText: '确认',
          confirmButtonClass: 'site_confirm_btn',
          customClass: 'site_confirm',
        }).then(() => {
          apiStationRead({
            id: item.id
          }).then(res => {
            this.getStationList(this.pages)
            this.$router.push({
              name: 'ContractInfo'
            })
          })
        }).catch(() => {
          apiStationRead({
            id: item.id
          }).then(res => {
            this.getStationList(this.pages)
          })
        });
      } else if (item.product_type === 8) {
        this.wxChatImgLink = ''
        apiStationRead({
          id: item.id
        }).then(res => {
          this.getStationList(this.pages)
          this.sendWxImg = true
          this.wxChatImgLink = item.imgurl
        })
      } else if (item.product_type === 9) {
        apiStationRead({
          id: item.id
        }).then(res => {
          this.getStationList(this.pages)
          apiGetCustomerQrcodeInfo({
            type: 1
          }).then(res => {
            if (res.data.customer_qr_code_flag == 1) {
              let dict = res.data.dict
              if (dict.hasOwnProperty(item.imgurl)) {
                for (const key in dict) {
                  if (key == item.imgurl) {
                    this.customer_describe = dict[key].customer_describe
                    this.qr_code_url = dict[key].qr_code_url
                    break
                  }
                }
              } else {
                apiGetCustomerQrcodeList({
                  game_id: item.game_id,
                  type: 1
                }).then(res => {
                  this.customer_describe = res.data.list[0].customer_describe
                  this.qr_code_url = res.data.list[0].qr_code_url
                })
              }
              this.merVisible = true
            } else {
              if (item.imgurl) {
                const params = item.imgurl == 'htmg' ?
                {
                  game_id: item.game_id,
                  ysdgcode: item.imgurl,
                  gameAlias: item.imgurl,
                  im_type: item.im_type
                } : {
                  game_id: item.game_id,
                  id: item.imgurl,
                  serviceId: item.imgurl,
                  im_type: item.im_type
                }
                this.$openIM(params)
              } else {
              }
            }
          })
        })
      } else if (item.product_type === 11 || item.product_type === 12) {
        apiStationRead({
          id: item.id
        }).then(res => {
          this.getStationList(this.pages)
          this.$alert(item.content, '消息通知', {
            confirmButtonText: '确认',
            confirmButtonClass: 'site_confirm_btn',
            customClass: 'site_confirm',
          }).then(res => {
            apiStationPay({
              product_type: item.product_type,
              order_id: item.order_id
            }).then(res => {
              const params = item.imgurl == 'htmg' ? {
                game_id: item.game_id,
                room_id:res.data.group_room_id,
                gameAlias: 'htmg',
                im_type: res.data.im_type
              }: {
                game_id: item.game_id,
                room_id:res.data.group_room_id,
                serviceId: item.imgurl,
                im_type: res.data.im_type
              }
              this.$openIM(params)
            }).catch(e=>{
              this.$message({
                center: true,
                message: e.msg,
                type: 'error'
              })
            })
          })

        })
      } else if (item.product_type === 13) {
        apiStationRead({
          id: item.id
        }).then(res => {
          this.getStationList(this.pages)
          this.$alert(item.content, '消息通知', {
            confirmButtonText: '确认',
            confirmButtonClass: 'site_confirm_btn',
            customClass: 'site_confirm',
          }).then(res => {
            apiconsultclick({
              id: item.id
            }).then(res => {
              const params = item.imgurl == 'htmg' ? {
                  game_id: item.game_id,
                  room_id:res.data.room_id,
                  gameAlias: 'htmg',
                  im_type: res.data.im_type
                }: {
                  game_id: item.game_id,
                  room_id:res.data.room_id,
                  serviceId: item.imgurl,
                  im_type: res.data.im_type
                }
                this.$openIM(params)
            }).catch(e=>{
              this.$message({
                center: true,
                message: e.msg,
                type: 'error'
              })
            })
          })

        })
      } else if(item.product_type === 16){
        apiStationRead({
          id: item.id
        }).then(res => {
          this.getStationList(this.pages)
          switch(item.inv_id){
            case 1:
              // 买家
              earnestDetail({
                order_id: item.order_id
              }).then(resp => {
                if(resp.data.status == 2){
                  // 跳转失败
                  this.$router.push({
                    name: 'BuyerBargainPrice',
                    query:{
                      status: 'fail'
                    }
                  })
                } else {
                  this.$router.push({
                    name: 'BuyerBargainPrice',
                  })
                }
              })
              break;
            case 2:
              // 卖家
              apiEarnestOrderDetail({
                id: item.order_id
              }).then(resp => {
                if(resp.data.status == 2){
                  // 跳转失败
                  this.$router.push({
                    name: 'SellerBargainPrice',
                    query:{
                      status: 'fail'
                    }
                  })
                } else {
                  this.$router.push({
                    name: 'SellerBargainPrice',
                  })
                }
              })
              break;
          }
        })
      } else {
        this.$alert(item.content, '消息通知', {
          confirmButtonText: '确认',
          confirmButtonClass: 'site_confirm_btn',
          customClass: 'site_confirm',
          callback: action => {
            apiStationRead({
              id: item.id
            }).then(res => {
              this.getStationList(this.pages)
            })
          }
        });
      }
    },
    /**
     * 获取 站内通知 列表
     * @param page 当前页码
     */
    getStationList(page) {
      apiStationList({
        page: page,
      }).then(res => {
        this.totalCount = res.data.total
        res.data.list.map(item => {
          if (item.product_type === 5) {
            let index = item.content.indexOf("。") + 1
            let content_top = item.content.slice(0, index)
            let content_a = item.content.slice(index)
            item.content = content_top
            item.content_link = content_a
            return item
          }
          return item
        })
        this.tableData = res.data.list
      })
    },
    /**
     * 一键已读
     */
    readAll() {
      this.pages = 1
      apiReadAll({}).then(res => {
        this.getStationList('1')
        this.$store.commit("set_chat_message", 0)
        this.$store.commit('set_siteNoticeMsg',0)
      })
    }
  },
  mounted() {
    //初始化数据
    this.getStationList(1)
  },
  watch: {},
  computed: {}
}
</script>
<!-- 弹框 -->
<style lang="less">
.site_confirm {
  width: 386px !important;
  //height: 232px !important;
  background: var(--bg-card, #FFFFFF) !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .el-message-box__header, .el-message-box__content, .el-message-box__btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .el-message-box__title {
    margin-top: 36px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
    line-height: 28px;
  }

  .el-message-box__message {
    padding: 0 30px;
  }

  .el-message-box__content > .el-message-box__container {
    margin-top: 30px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
  }

  .site_confirm_btn {
    margin: 36px 0;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 4px;
    border: none;
    font-size: 15px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 500;
    color: #FFFFFF !important;
    box-shadow: 0 8px 18px rgba(255, 90, 31, 0.18);
  }

  .site_confirm_btn:hover {
    background: var(--primary-hover, #E84A12) !important;
    opacity: 1;
  }
}

#site_notice {
  .sendWxImgWrapper {
    border-radius: 4px !important;
    text-align: center;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    .wxImgWrapper {
      text-align: center;

      span {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: var(--text-main, #111827);
      }

      .wxchatImg {
        width: 220px;
        height: 220px;
        display: inline-block;
        margin: 20px 0 10px;
      }

      .Imggreen {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #32B440;

        img {
          width: 15px;
          height: 15px;
          margin-right: 4px;
        }
      }

      .text-tip {
        font-size: 16px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-muted, #9AA0AC);
        margin-top: 10px;
      }
    }
  }
}
</style>
<style lang='less' scoped>
#site_notice {
  padding: 20px;
  display: flex;
  flex-direction: column;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .tabbar {
    min-height: 40px;
    height: auto;
    margin: 0 0 18px;
    padding: 4px 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    overflow: visible;
    background: transparent;
    border: none;
    border-radius: 0;

    div {
      min-width: 84px;
      height: 34px;
      margin-right: 0;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      background: transparent;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;
    }

    div:hover {
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .isAcitve {
      padding-bottom: 0;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 500;
      background: var(--bg-dark, #1A1D24);
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
    }

    .isAcitve:hover {
      color: #FFFFFF;
      background: var(--bg-dark, #1A1D24);
    }

    div:last-of-type {
      margin: 0;
    }

    .all_read {
      flex: 1;
      height: 34px;
      margin-right: 0;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #1A1D24);
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: pointer;
      user-select: none;
      transition: color .2s ease;

      i {
        margin-right: 6px;
        font-size: 16px;
      }

      &:hover {
        color: var(--primary, #FF5A1F);
      }
    }

    .all_read--disabled {
      color: var(--text-muted, #9AA0AC);
      cursor: not-allowed;
      opacity: .72;

      &:hover {
        color: var(--text-muted, #9AA0AC);
      }
    }
  }

  .notice_list {
    min-height: 520px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    .notice_wrapper {
      position: relative;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: stretch;
      min-height: 98px;
      transition: background .2s ease, box-shadow .2s ease;

      &:hover {
        background: var(--bg-tag, #F0EDE8);

        .notice_right {
          opacity: 1;
          color: var(--text-main, #1A1D24);
        }
      }

      .notice_left {
        display: none;
      }

      .notice_center {
        min-width: 0;
        margin-left: 0;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        padding: 18px 22px;
        flex: 1;

        .not_cen_top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;

          .not_cen_title {
            min-width: 0;
            font-size: 15px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 600;
            color: var(--text-main, #111827);
            line-height: 22px;
            position: relative;
            padding-left: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &::before {
              content: ' ';
              position: absolute;
              width: 6px;
              height: 6px;
              top: 8px;
              left: 0;
              border-radius: 50%;
              background: var(--text-muted, #9AA0AC);
            }
          }

          .not_cen_time {
            flex-shrink: 0;
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: var(--text-muted, #9AA0AC);
            line-height: 20px;
          }
        }

        .notice_content {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 18px;
          margin-top: 12px;

          .item_content {
            min-width: 0;
            flex: 1;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            line-height: 22px;
          }
        }
      }

      .notice_right {
        width: 46px;
        flex: 0 0 46px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--text-muted, #9AA0AC);
        font-size: 20px;
        opacity: .68;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        transition: color .2s ease, opacity .2s ease;
      }
    }

    .notice_list_item_unread {
      background: var(--bg-card, #FFFFFF);

      .notice_center {
        background: transparent;

        .not_cen_title {
          color: var(--text-main, #111827);
          font-weight: 600;

          &::before {
            background: var(--hot, #FF2D55);
          }

          &::after {
            content: '新消息';
            height: 20px;
            margin-left: 8px;
            padding: 0 8px;
            display: inline-flex;
            align-items: center;
            border-radius: 4px;
            background: var(--primary-soft, #FCEDE5);
            color: var(--primary, #FF5A1F);
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 500;
            line-height: 20px;
            vertical-align: 1px;
          }
        }
      }

      &:hover {
        background: var(--bg-tag, #F0EDE8);
      }

      .item_state {
        flex-shrink: 0;

        /deep/ .el-tag--warning {
          height: 28px;
          padding: 0 10px;
          display: inline-flex;
          align-items: center;
          background: var(--primary-soft, #FCEDE5) !important;
          border-radius: 4px;
          font-size: 13px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 500;
          color: var(--gold, #C9974D) !important;
          border: none;
        }
      }

      .item_btn {
        width: 100px;
        height: 30px;
        line-height: 30px;
        background: #FFDB51;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: #000000;
        text-align: center;
        cursor: pointer;
      }
    }

    .notice_list_item {
      background: var(--bg-card, #FFFFFF);

      .item_state {
        flex-shrink: 0;

        /deep/ .el-tag--info {
          height: 28px;
          padding: 0 10px;
          display: inline-flex;
          align-items: center;
          background: var(--bg-tag, #F0EDE8);
          border-radius: 4px;
          font-size: 13px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 500;
          color: var(--text-muted, #9AA0AC);
          border: none;
        }
      }

      .item_btn {
        width: 100px;
        height: 30px;
        line-height: 30px;
        background: #F0F0F0;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: #A7A7A7;
        text-align: center;
      }
    }

    .pages {
      min-height: 86px;
      padding: 0 0 28px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .notice_wrapper:last-of-type {
      .notice_center,
      .notice_right {
        border-bottom: none;
      }
    }
  }

  .no_data {
    min-height: 520px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
